import { ErrorState, LoadingSkeleton } from "../ui";
import { useNextT } from "../i18n";
import { useAccess } from "../access/api";
import { SwitchRoute } from "../routes/SwitchRoute";
import type { SwitchEntry } from "../routes/switchboard";
import { canOpenReports, reportsMode } from "./reportsAccess";
import { NotAvailablePage } from "./pages/NotAvailablePage";

/**
 * The guard of /duchot, aware of the switchboard:
 *  - the new page is served: it waits for the access answer; See visit history or Write reports opens the page, everyone else
 *    (volunteers too) reads board 137;
 *  - today's page is served: exactly today's guards (`LegacyReportsPage` carries them), with no new request on that path.
 * Both pages come from the switchboard line, so a flip of `mode` is the whole switch.
 */
export const ReportsRoute = ({ board }: { board?: SwitchEntry[] }) =>
  reportsMode(board) === "next" ? <ScopeGuard board={board} /> : <SwitchRoute path="/duchot" board={board} />;

const ScopeGuard = ({ board }: { board?: SwitchEntry[] }) => {
  const { t } = useNextT();
  const { data, isLoading, error, refetch } = useAccess();
  if (error) return <div className="cy-next"><ErrorState title={t("reports.access.failed_title")} body={t("reports.access.failed_body")} onRetry={() => { void refetch?.(); }} /></div>;
  if (isLoading || !data) return <div className="cy-next"><LoadingSkeleton rows={4} label={t("reports.access.loading")} /></div>;
  if (!canOpenReports(data)) return <NotAvailablePage />;
  return <SwitchRoute path="/duchot" board={board} />;
};
